import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=1cb218be&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb218be",
  null
  
)

export default component.exports